import { GeoInfo, GeolocationApi } from './geolocation.api';

export function createGeolocationApi(): GeolocationApi {
  return {
    search: async (query: string) => {
      if (!query) {
        return [];
      }

      // Read on each call: the Maps script loads async and may arrive after this module.
      const google = window['google'] as any;

      if (!google?.maps?.places?.AutocompleteService) {
        throw new Error(
          `Google Maps JS API not loaded (google.maps: ${typeof google?.maps}).`
        );
      }

      const service = new google.maps.places.AutocompleteService();

      const predictions = await new Promise<any[]>((resolve, reject) => {
        service.getPlacePredictions({ input: query }, (results, status) => {
          if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            return resolve([]);
          }
          if (
            status !== google.maps.places.PlacesServiceStatus.OK ||
            !results
          ) {
            return reject(new Error(`Google Places API error: ${status}`));
          }
          resolve(results);
        });
      });
      const infos = predictions.map<GeoInfo>(prediction => ({
        id: prediction.place_id,
        name: prediction.structured_formatting.main_text,
        description: prediction.structured_formatting.secondary_text
      }));
      return infos;
    }
  };
}
